import { Institution, UpdateStatusEvent } from "@/api/dtos";
import IsLoading from "@/components/layouts/IsLoading";
import Show from "@/components/layouts/Show";
import InstitutionStatusList from "@/components/lists/status/InstitutionStatusList";
import InstitutionsContext from "@/contexts/data/InstitutionsContext";
import TrialContext from "@/contexts/data/TrialContext";
import useInstitutionStatuses from "@/hooks/data/useInstitutionStatuses";
import useStatusUpdate from "@/hooks/data/useStatusUpdate";
import { Typography, useTheme } from "@mui/material";
import { FC, useCallback, useContext } from "react";


const Institutions: FC = () => {
    const theme = useTheme();
    const { data: trial } = useContext(TrialContext);
    const { data: institutions } = useContext(InstitutionsContext);
    const { idMap: institutionStatuses, loading: institutionStatusesLoading, validating: institutionStatusesValidating, refresh: institutionStatusesRefresh } = useInstitutionStatuses(trial?.id);

    const updateStatuses = useCallback(async (event: UpdateStatusEvent) => {
        if (event.trialId == trial?.id) {
            await institutionStatusesRefresh()
        }
    }, [institutionStatusesRefresh, trial]);

    const {processing, queueUpdate, error} = useStatusUpdate(
        updateStatuses,
        updateStatuses
    );

    const queueStatusUpdate = useCallback(async (item: Institution) => {
        await queueUpdate({ institutionId: item.id });
        await institutionStatusesRefresh();
    }, [queueUpdate, institutionStatusesRefresh])
    
    const loading = institutionStatusesLoading;
    const validating = institutionStatusesValidating || processing;

    return (
        <>
            <IsLoading name="institutions-page" loading={loading} validating={validating} />
            <Show show={!loading}>
                <Typography variant="h1" gutterBottom>
                    Institutions
                </Typography>
                <InstitutionStatusList 
                    data={institutions}
                    statuses={institutionStatuses}
                    queueUpdate={queueStatusUpdate}
                />
            </Show>
        </>
    )
};

export default Institutions;